module.exports = __webpack_public_path__ + "static/media/logo_nav.45d70a7c.png";